import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { InputBox } from "../../components/CustomWidgets/InputBox";
import "react-phone-number-input/style.css";
import SelectBox from "../CustomWidgets/SelectBox";
import { Button, Input, Table, Modal } from "antd";
import "../../styles.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { UpdateRetailerDetails } from "../../API  Functions/ProfileFunctions";
import LoadingSpinner from "../Loading";
import { checkPermission } from "../../Utils/permissionHelper";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import { toast } from "react-toastify";
import { Trash2 } from "lucide-react"; // delete icon
import UpdatedProfile from "../../modals/UpdatedProfile";

import { Select } from "antd";
const { Option } = Select;


const SerialNumberCell = ({ record, serialList, setSerialList }) => {
    const { t } = useTranslation();

    const [localValue, setLocalValue] = React.useState(record.serial_number);

    useEffect(() => {
        setLocalValue(record.serial_number);
    }, [record.serial_number]);

    const handleBlur = () => {
        const trimmed = localValue.trim();
        if (!trimmed) return;

        const duplicate = serialList.some(
            (s) => s.serial_number === trimmed && s.serial_number !== record.serial_number
        );

        if (duplicate) {
            toast.error(t("Duplicate serial number not allowed"));
            setLocalValue(record.serial_number);
            return;
        }

        // ✅ Only update global list if changed
        if (trimmed !== record.serial_number) {
            setSerialList(prev =>
                prev.map(s =>
                    s.id === record.id
                        ? { ...s, serial_number: trimmed }
                        : s
                )
            );
        }
    };

    return (
        <Input
            value={localValue}
            onChange={(e) =>
                setLocalValue(e.target.value.replace(/[^a-zA-Z0-9]/g, ""))
            }
            onBlur={handleBlur}
            className="w-[200px] h-[40px]"
            maxLength={20}
        />
    );
};


const ETASetup = ({ payload, onDataSubmit, profiledetail, data, fetchdetails }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showUpdatedProfile, setShowUpdatedProfile] = useState(false);
    const [restricted, setrestricted] = useState(true);
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [serialNumber, setSerialNumber] = useState("");
    const [serialList, setSerialList] = useState([]);
    const [confirmVisible, setConfirmVisible] = useState(false);

    const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
    const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

    const [initialState, setInitialState] = useState({});
    const [isChanged, setIsChanged] = useState(false);

    const [deletedSerials, setDeletedSerials] = useState([]);


    useEffect(() => {
        getStoreusers();
    }, []);

    const getStoreusers = () => {
        setLoading(true);
        getStoreUsers(user_id)
            .then((res) => {
                if (res?.result[0]?.status_code === 200) {
                    const users = res.result[0]?.response;
                    if (users) setUsers(users);
                }
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (data) {
            const addr = data.retailer_details?.shop_address;
            const fullAddress = addr
                ? `${addr.street || ""}, ${addr.street2 || ""}, ${addr.city || ""}, ${addr.state || ""}, ${addr.country || ""}, ${addr.zip || ""}`
                : "";

            formik.setValues({
                business_name: data.retailer_details.company_name || "",
                business_name_ar: data.retailer_details.company_name_ar || "",
                business_address: fullAddress,
                tax_card_number: data.retailer_details.tax_card_number || "",
                tax_activity_code: data.retailer_details.tax_activity_code || "",
                user_id: payload.user_id,
                store_id: payload.store_id,
            });

            if (
                data.retailer_details.serial_number &&
                Array.isArray(data.retailer_details.serial_number)
            ) {
                const formatted = data.retailer_details.serial_number.map((item) => ({
                    id: item.id,
                    serial_number: item.serial,
                    user_id: item?.user_id || null,
                    is_delete: false,
                }));
                setSerialList(formatted);

                setInitialState({
                    tax_card_number: data.retailer_details.tax_card_number || "",
                    tax_activity_code: data.retailer_details.tax_activity_code || "",
                    serialList: formatted,
                });
            }
        }
    }, [data]);

    const formik = useFormik({
        initialValues: {
            business_name: "",
            business_name_ar: "",
            business_address: "",
            tax_card_number: "",
            tax_activity_code: "",
            user_id: payload.user_id,
            store_id: payload.store_id,
        },
        onSubmit: async (values) => {
            if (!checkPermission("/settings/profile", isGinne)) return;

            setLoading(true);
            try {
                // ✅ Convert to required structure
                const serialArray = [
                    ...serialList.map((s) => ({
                        id: s.id,
                        serial: s.serial_number,
                        user_id: s.user_id || null,
                        is_delete: false,
                    })),
                    ...deletedSerials.map((s) => ({
                        id: s.id,
                        serial: s.serial_number,
                        user_id: s.user_id || null,
                        is_delete: true,
                    })),
                ];


                const apipayload = {
                    user_id,
                    // shop_name: values.business_name,
                    // shop_name_ar: values.business_name_ar,
                    // business_address: values.business_address,
                    tax_card_number: values.tax_card_number,
                    tax_activity_code: values.tax_activity_code,
                    serial_number: serialArray,
                };

                const response = await UpdateRetailerDetails(apipayload);

                if (response?.status === "Update Successfully") {
                    setShowUpdatedProfile(true);
                    onDataSubmit();
                    setrestricted(true);

                    setInitialState({
                        tax_card_number: values.tax_card_number,
                        tax_activity_code: values.tax_activity_code,
                        serialList: serialList,
                    });
                    setIsChanged(false);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        },
    });

    const checkIfChanged = (newSerialList, newValues) => {
        const initial = initialState;

        if (!initial || !initial.serialList) return true; // if initial not ready yet

        // Check if tax or activity changed
        if (
            initial.tax_card_number !== newValues.tax_card_number ||
            initial.tax_activity_code !== newValues.tax_activity_code
        ) {
            return true;
        }

        // Compare serial count
        if (initial.serialList.length !== newSerialList.length) return true;

        // Compare each serial number + assigned user
        const changed = newSerialList.some((s, i) => {
            const init = initial.serialList[i];
            return (
                s.serial_number !== init.serial_number ||
                (s.user_id || null) !== (init.user_id || null)
            );
        });

        return changed;
    };

    useEffect(() => {
        const changed = checkIfChanged(serialList, formik.values);
        setIsChanged(changed);
    }, [serialList, formik.values.tax_card_number, formik.values.tax_activity_code]);


    const handleAddSerial = () => {
        if (!serialNumber.trim()) return;

        if (serialList.some((s) => s.serial_number === serialNumber.trim())) {
            toast.error(t("Duplicate serial number not allowed"));
            return;
        }

        const newSerial = {
            id: null,
            tempId: Date.now() + Math.random(),
            serial_number: serialNumber.trim(),
            user_id: null
        };

        setSerialList([...serialList, newSerial]);
        setSerialNumber("");
    };



    const handleDeleteSerial = (id) => {
        const item = serialList.find(s => s.id === id);

        // If item exists and has a valid id, mark it deleted for API
        if (item && item.id !== null) {
            setDeletedSerials(prev => [
                ...prev,
                { ...item, is_delete: true }
            ]);
        }

        // Remove from UI table
        setSerialList(prev => prev.filter(s => s.id !== id));
    };

    const handleUserAssign = (rowKey, userId) => {
        setSerialList(prev =>
            prev.map(s =>
                (s.id ?? s.tempId) === rowKey
                    ? { ...s, user_id: userId }
                    : s
            )
        );
    };



    const handleSerialEdit = (id, newSerial) => {
        if (!newSerial.trim()) return;

        const duplicate = serialList.some(
            s => s.serial_number === newSerial.trim() && s.id !== id
        );
        if (duplicate) {
            toast.error(t("Duplicate serial number not allowed"));
            return;
        }

        setSerialList(prev =>
            prev.map(s =>
                s.id === id ? { ...s, serial_number: newSerial.trim() } : s
            )
        );
    };
    const columns = [

        {
            title: (t("Serial Number")),
            dataIndex: "serial_number",
            key: "serial_number",
            render: (text, record) => (
                <SerialNumberCell
                    record={record}
                    serialList={serialList}
                    setSerialList={setSerialList}
                />
            ),
        },

        {
            title: (t("Assign to User")),
            dataIndex: "user_id",
            key: "assign_user",
            render: (text, record) => (
                <Select
                    style={{ width: "80%" }}
                    placeholder={t("Select User")}
                    className="h-10"
                    showSearch
                    value={record.user_id || null} // ✅ controlled by user_id
                    onChange={(value) => handleUserAssign(record.id ?? record.tempId, value)}
                    optionFilterProp="children"
                >
                    {users?.map((user) => (
                        <Option key={user.user_id} value={user.user_id}>
                            {user.name}
                        </Option>
                    ))}
                </Select>
            ),
        },
        {
            title: (t("Action")),
            key: "action",
            render: (_, record) => (
                <Trash2
                    className="text-red-500 cursor-pointer hover:scale-110 transition-transform"
                    onClick={() => handleDeleteSerial(record.id)}
                    size={18}
                />
            ),
        },
    ];


    return (
        <>
            {loading && <LoadingSpinner />}

            {/* Note Section */}
            <div className="mx-8 mt-4 text-gray-600 italic text-sm">
                {t("Note: The information below must be exactly the same as what you submitted to the ETA during registration.")}
            </div>

            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    setConfirmVisible(true);
                }}
            >
                <div className="font-normal text-[#5c5c5c] mx-8 ">
                    <div className="grid grid-cols-2 gap-6 my-4">
                        <InputBox
                            name="business_name"
                            label={t("Business Name")}
                            backgroundColor={"#EBEBEB"}
                            disabled
                            value={formik.values.business_name}
                            className="cursor-not-allowed"
                        />
                        <InputBox
                            name="business_address"
                            label={t("Business Address")}
                            backgroundColor={"#EBEBEB"}
                            disabled
                            value={formik.values.business_address}
                            className="cursor-not-allowed"
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-6 my-4">
                        <InputBox
                            name="tax_card_number"
                            label={t("Tax ID / RIN / TRN")}
                            placeholder={t("Enter 9 digits")}
                            maxLength={9}
                            onChange={(val) => {
                                if (/^\d{0,9}$/.test(val.target.value)) {
                                    formik.setFieldValue("tax_card_number", val.target.value);
                                }
                            }}
                            value={formik.values.tax_card_number}
                        />
                        <InputBox
                            name="tax_activity_code"
                            label={t("Tax Activity Code")}
                            placeholder={t("Enter 4 digits")}
                            maxLength={4}
                            onChange={(val) => {
                                if (/^\d{0,4}$/.test(val.target.value)) {
                                    formik.setFieldValue("tax_activity_code", val.target.value);
                                }
                            }}
                            value={formik.values.tax_activity_code}
                        />
                    </div>

                    {/* Serial Number Section */}
                    <div className="my-6">
                        <label className="block text-sm mb-2">{t("Serial Number")}</label>
                        <div className="flex gap-3">
                            <Input
                                placeholder="Enter Serial Number"
                                value={serialNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Allow only letters (A-Z, a-z) and numbers (0-9)
                                    const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '');
                                    setSerialNumber(filteredValue);
                                }}
                                className="w-[300px] h-[40px]"
                                maxLength={20}
                            />
                            <Button
                                type="button"
                                onClick={handleAddSerial}
                                className="text-primaryBlue mt-1 font-semibold rounded-lg inline border border-primaryBlue"
                            >
                                {("Add")}
                            </Button>
                        </div>
                    </div>

                    <Table
                        dataSource={serialList}
                        columns={columns}
                        rowKey={(record) => record.id ?? record.tempId}
                        pagination={false}
                        className="mt-4"
                    />
                </div>

                <div className="flex gap-5 mx-11 mt-8 mb-10 ">
                    <button
                        type="submit"
                        disabled={!isChanged}
                        className={`w-[180px] h-[45px] rounded-lg font-semibold ${isChanged
                            ? "bg-primaryBlue text-white"
                            : "bg-primaryBlue text-white opacity-60 cursor-not-allowed"
                            }`}
                    >
                        {t("Update & Save")}
                    </button>

                </div>
            </form>

            {/* Confirmation Modal */}
            <Modal
                title={t("Confirm Update")}
                open={confirmVisible}
                onCancel={() => setConfirmVisible(false)}
                onOk={() => {
                    setConfirmVisible(false);
                    formik.handleSubmit();
                }}
                okText={t("Confirm")}
                cancelText={t("Cancel")}
                okButtonProps={{
                    className: "bg-primaryBlue hover:bg-primaryBlue text-white border-none"
                }}
            >
                <p>{t("Please check all the details carefully before proceeding.")}</p>
            </Modal>

            {showUpdatedProfile && (
                <UpdatedProfile
                    onClose={() => {
                        setShowUpdatedProfile(false);
                        fetchdetails();
                    }}
                    message={t("ETA Setup Details Updated")}
                />
            )}
        </>
    );
};

export default ETASetup;
